export default "__VITE_ASSET__D$QE49CF__"